import Moment from "moment";
import moment from "moment-business-days";
import React, { Component } from "react";
import Resizer from "react-image-file-resizer";
import * as alerts from "../actions/Alert";
import performRequest from "../configAxios";

export const Roles = {
  Admin: "ADMIN", // 1
  Customer: "CUSTOMER", // 2
  Agent: "AGENT", // 3
  Kyc: "KYC", // 4
  BusinessManager: "BUSINESS_MANAGER", // 5
  FinanceManager: "FINANCE_MANAGER", // 6
  AgentsManager: "AGENTS_MANAGER", // 7
  Auditor: "AUDITOR", // 8
};

export const CONTRACT_TYPES = {
  OPEN: "OPEN",
  CLOSED: "CLOSED",
};

export const ContractStates = {
  Active: "ACTIVE",
  Inactive: "INACTIVE",
  Archive: "ARCHIVE",
  Terminated: "TERMINATED",
};

export const ContractPhases = {
  WaitingSign: "WAITING_SIGN", // 0
  WaitingAport: "WAITING_APORT", // 1
  Validating: "VALIDATING", // 2
  Executing: "EXECUTING", // 3
  WaitingWithdraw: "WAITING_WITHDRAW", // 4
  Redeemed: "REDEEMED", // 5
  Canceled: "CANCELED", // 6
};

const PHASE_SORT_ORDER = {
  [ContractPhases.Executing]: 0,
  [ContractPhases.WaitingSign]: 1,
  [ContractPhases.WaitingAport]: 2,
  [ContractPhases.Validating]: 3,
  [ContractPhases.WaitingWithdraw]: 4,
  [ContractPhases.Redeemed]: 5,
  [ContractPhases.Canceled]: 6,
};

export const PaymentTypes = {
  BONUS: 0,
  REDEMPTION: 1,
  PROFIT: 2,
  FUTURE_PROFIT: 3,
  BONUS_SPLIT: 4,
  BONUS_MANAGER: 5,
  BONUS_RECOMMENDANT: 6,
  BONUS_MANAGER_SPLIT: 7,
  BONUS_LEADERSHIP_ONE_TIME: 8,
  BONUS_LEADERSHIP_MONTHLY: 9,
};

const DEFAULT_SORT_ORDER = Number.MAX_SAFE_INTEGER;

export const compareByPhase = (a, b) => {
  const phaseA = PHASE_SORT_ORDER[a?.phase] ?? DEFAULT_SORT_ORDER;
  const phaseB = PHASE_SORT_ORDER[b?.phase] ?? DEFAULT_SORT_ORDER;
  return phaseA - phaseB;
};

export const compareByPhaseAndInitialDateAndId = (a, b) => {
  const phaseDiff = compareByPhase(a, b);

  if (phaseDiff !== 0) {
    return phaseDiff;
  }

  const initialDateDiff = b?.initialDate?.localeCompare(a?.initialDate);
  if (initialDateDiff !== 0) {
    return initialDateDiff;
  }
  return b.id - a.id;
};

export const getLocationParam = (location, param) => new URLSearchParams(location.search).get(param);

export const ListRoles = [
  { name: "ADMIN", label: "app.enuns.ADMIN", value: true }, // 1
  { name: "CUSTOMER", label: "app.enuns.CUSTOMER", value: true }, // 2
  { name: "AGENT", label: "app.enuns.AGENT", value: true }, // 3
  { name: "KYC", label: "app.enuns.KYC", value: true }, // 4
  { name: "BUSINESS_MANAGER", label: "app.enuns.BUSINESS_MANAGER", value: true }, // 5
  { name: "FINANCE_MANAGER", label: "app.enuns.FINANCE_MANAGER", value: true }, // 6
  { name: "AGENTS_MANAGER", label: "app.enuns.AGENTS_MANAGER", value: true }, // 7
  { name: "AUDITOR", label: "app.enuns.AUDITOR", value: true }, // 8
];

export const AgreementTypes = {
  Agent: "AGENT", // 0
  Manager: "MANAGER", // 1
};

const ROLES_FOR_FULL_REPORT = [Roles.Admin, Roles.FinanceManager, Roles.Auditor];
const ROLES_FOR_BASIC_REPORT = [...ROLES_FOR_FULL_REPORT, Roles.BusinessManager, Roles.Agent];

export const ListContractColumns = [
  { name: "id", label: "app.id", value: true, roles: ROLES_FOR_BASIC_REPORT },
  { name: "customer", label: "app.customer", value: true, roles: ROLES_FOR_BASIC_REPORT },
  { name: "agent", label: "app.agent", value: true, roles: ROLES_FOR_BASIC_REPORT },
  { name: "agentManager", label: "app.agentManager", value: true, roles: ROLES_FOR_BASIC_REPORT },
  { name: "custodianLct", label: "app.custodian.lct", value: true, roles: ROLES_FOR_BASIC_REPORT },
  { name: "type", label: "app.type", value: true, roles: ROLES_FOR_BASIC_REPORT },
  { name: "durationInMonth", label: "app.durationInMonth", value: true, roles: ROLES_FOR_BASIC_REPORT },
  { name: "segmentName", label: "app.investment.title", value: true, roles: ROLES_FOR_FULL_REPORT },
  { name: "createdAt", label: "app.contractReport.createdAt", value: true, roles: ROLES_FOR_FULL_REPORT },
  { name: "activation", label: "app.activation", value: true, roles: ROLES_FOR_BASIC_REPORT },
  { name: "rescue", label: "app.rescue", value: true, roles: ROLES_FOR_BASIC_REPORT },
  { name: "situation", label: "app.situation", value: true, roles: ROLES_FOR_BASIC_REPORT },
  { name: "limitMonthyPercent", label: "app.limit.monthly.percent", value: true, roles: ROLES_FOR_FULL_REPORT },
  { name: "limitMonthyLct", label: "app.limit.monthly.lct", value: true, roles: ROLES_FOR_FULL_REPORT },
  { name: "comissionPercent", label: "app.comission.percent", value: true, roles: ROLES_FOR_FULL_REPORT },
  { name: "comissionLct", label: "app.comission.lct", value: true, roles: ROLES_FOR_FULL_REPORT },
  { name: "comissionManagerPercent", label: "app.comissionManager.percent", value: true, roles: ROLES_FOR_FULL_REPORT },
  { name: "comissionManagerLct", label: "app.comissionManager.lct", value: true, roles: ROLES_FOR_FULL_REPORT },
];

export const ListUserColumns = [
  { name: "id", label: "app.id", value: true }, // 1
  { name: "name", label: "app.name", value: true },
  { name: "txtRole", label: "app.role", value: true },
  { name: "telefone", label: "app.phone", value: true },
  { name: "telefone2", label: "app.phone", value: true },
  { name: "email", label: "app.email", value: true },
  { name: "txtEmailConfirmed", label: "app.email.confirmed", value: true },
  { name: "txtActive", label: "app.apt", value: true },
  { name: "txtCreatedAt", label: "app.dateRegister", value: true },
  { name: "txtActivationDate", label: "app.date.active", value: true },
  { name: "txtDateOfBirth", label: "app.dateOfBirth", value: true },
  { name: "app.agent", label: "app.agent", value: true },
];

export const Enuns = {
  ADDRESS: "app.enuns.ADDRESS",
  ID: "app.enuns.ID",
  SOCIAL_CONTRACT: "app.enuns.SOCIAL_CONTRACT",
  ID_WITH_PHOTO: "app.enuns.ID_WITH_PHOTO",
  ATTACHMENT: "app.enuns.ATTACHMENT",
  APPROVED: "app.enuns.APPROVED",
  PENDING: "app.enuns.PENDING",
  ANALYZING: "app.enuns.ANALYZING",
  CANCEL: "app.enuns.CANCEL",
  REJECTED: "app.enuns.REJECTED",
  ARCHIVE: "app.enuns.TERMINATED",
  ACTIVE: "app.enuns.USER_ACTIVE",
  INACTIVE: "app.inactive",
  TERMINATED: "app.enuns.TERMINATED",
  EXECUTING: "app.enuns.EXECUTING",
  WAITING_WITHDRAW: "app.enuns.WAITING_WITHDRAW",
  WAITING_SIGN: "app.enuns.WAITING_SIGN",
  WAITING_APORT: "app.enuns.WAITING_APORT",
  VALIDATING: "app.enuns.VALIDATING",
  REDEEMED: "app.enuns.REDEEMED",
  WAITING_PAYMENT_REDEEMED: "app.enuns.WAITING_PAYMENT_REDEEMED",
  CANCELED: "app.enuns.CANCEL",
  CONFIRM_WITHDRAW: "app.withdraw.confirm",
  USER_ACTIVE: "app.enuns.ACTIVE",
  USER_INACTIVE: "app.enuns.USER_INACTIVE",
  USER_PENDING: "app.enuns.USER_PENDING",
  REAPORT_CONFIRM: "app.enuns.REAPORT_CONFIRM",
  REAPORT_CONFIRMED: "app.enuns.REAPORT_CONFIRMED",
  REAPORT_SENDED: "app.enuns.REAPORT_SENDED",
  ROLE_ADMIN: "app.enuns.ROLE_ADMIN",
  ROLE_KYC: "app.enuns.ROLE_KYC",
  ROLE_BUSINESS_MANAGER: "app.enuns.BUSINESS_MANAGER",
};

export const HashResult = {
  OK: "OK",
  NOT_FOUND: "NOT_FOUND",
  INCORRECT_TYPE: "INCORRECT_TYPE",
  INCORRECT_TOKEN: "INCORRECT_TOKEN",
  DEST_ADDR_NOT_PRESENT: "DEST_ADDR_NOT_PRESENT",
  INCORRECT_AMOUNT: "INCORRECT_AMOUNT",
  DATE_TOO_OLD: "DATE_TOO_OLD",
  NOT_ENOUGH_CONFIRMATIONS: "NOT_ENOUGH_CONFIRMATIONS",
  INVALID_TX: "INVALID_TX",
  REQUEST_ERROR: "REQUEST_ERROR",
  ALREADY_USED_TX: "ALREADY_USED_TX",
  TOKEN_MISMATCH: "TOKEN_MISMATCH",
};

export const HashType = {
  TRANSACTION: "TX",
  ADDRESS: "ADDR",
};

export const Currencies = {
  USD: "app.currency.usd",
  BRL: "app.currency.brl",
  EUR: "app.currency.eur",
};

export const partnerWithdrawTypeByNetwork = {
  "BTC/BTC": 0,
  "USDT/TRX": 1,
  "USDT/ETH": 2,
  "ETH/ETH": 3,
  "USDT/BSC": 4,
  "USDC/ETH": 5,
  "USDC/TRX": 6,
  "USDT/POL": 7,
  "USDC/POL": 8,
  "POL/POL": 9,
};

export const networkByPartnerWithdrawType = {
  0: "BTC/BTC",
  1: "USDT/TRX",
  2: "USDT/ETH",
  3: "ETH/ETH",
  4: "USDT/BSC",
  5: "USDC/ETH",
  6: "USDC/TRX",
  7: "USDT/POL",
  8: "USDC/POL",
  9: "POL/POL",
};

export const networkNameByPartnerWithdrawType = {
  0: "BTC - Bitcoin",
  1: "USDT TRC20 - Tron (TRX)",
  2: "USDT ERC20 - Ethereum (ETH)",
  4: "USDT BEP20 - Binance Smart Chain (BSC)",
  3: "ETH - Ether (Ethereum)",
  5: "USDC - ETHEREUM (ERC20)",
  6: "USDC - TRON (TRC20)",
  7: "USDT - Polygon",
  8: "USDC - Polygon",
  9: "POL - Polygon",
};

export const networkNameByNetwork = {
  "BTC/BTC": networkNameByPartnerWithdrawType[partnerWithdrawTypeByNetwork["BTC/BTC"]],
  "USDT/TRX": networkNameByPartnerWithdrawType[partnerWithdrawTypeByNetwork["USDT/TRX"]],
  "USDT/ETH": networkNameByPartnerWithdrawType[partnerWithdrawTypeByNetwork["USDT/ETH"]],
  "USDT/BSC": networkNameByPartnerWithdrawType[partnerWithdrawTypeByNetwork["USDT/BSC"]],
  "ETH/ETH": networkNameByPartnerWithdrawType[partnerWithdrawTypeByNetwork["ETH/ETH"]],
  "USDC/ETH": networkNameByPartnerWithdrawType[partnerWithdrawTypeByNetwork["USDC/ETH"]],
  "USDC/TRX": networkNameByPartnerWithdrawType[partnerWithdrawTypeByNetwork["USDC/TRX"]],
  "USDT/POL": networkNameByPartnerWithdrawType[partnerWithdrawTypeByNetwork["USDT/POL"]],
  "USDC/POL": networkNameByPartnerWithdrawType[partnerWithdrawTypeByNetwork["USDC/POL"]],
  "POL/POL": networkNameByPartnerWithdrawType[partnerWithdrawTypeByNetwork["POL/POL"]],
};

export const Visibility = {
  DIRECT_BELOW: "DIRECT_BELOW",
  BELOW_AGENTS: "BELOW_AGENTS",
  ALL_BELOW: "ALL_BELOW",
  UNLIMITED: "UNLIMITED",
};

export const Permissions = {
  ARCHIVE: "ARCHIVE",
  CHANGE_AGENT: "CHANGE_AGENT",
  CLEAR_AGENT: "CLEAR_AGENT",
  PROMOTE_TO_AGENT: "PROMOTE_TO_AGENT",
  DEMOTE_FROM_AGENT: "DEMOTE_FROM_AGENT",
  RESET_AGREEMENT_STATUS: "RESET_AGREEMENT_STATUS",
  EDIT_AGREEMENT_JOB_TITLE: "EDIT_AGREEMENT_JOB_TITLE",
  EDIT_AGREEMENT_CLASS: "EDIT_AGREEMENT_CLASS",
  EDIT_AGREEMENT_CLASS_LOWER_LEVEL: "EDIT_AGREEMENT_CLASS_LOWER_LEVEL",
  EDIT_AGREEMENT_MONTHLY_COMMISSION: "EDIT_AGREEMENT_MONTHLY_COMMISSION",
  EDIT_AGREEMENT_MONTHLY_COMMISSION_LOWER_LEVEL: "EDIT_AGREEMENT_MONTHLY_COMMISSION_LOWER_LEVEL",
  EDIT_AGREEMENT_ONE_TIME_COMMISSION: "EDIT_AGREEMENT_ONE_TIME_COMMISSION",
  EDIT_AGREEMENT_ONE_TIME_COMMISSION_LOWER_LEVEL: "EDIT_AGREEMENT_ONE_TIME_COMMISSION_LOWER_LEVEL",
  EDIT_AGREEMENT_LIMIT: "EDIT_AGREEMENT_LIMIT",
  EDIT_AGREEMENT_LIMIT_LOWER_LEVEL: "EDIT_AGREEMENT_LIMIT_LOWER_LEVEL",
  EDIT_AGREEMENT_INVESTMENT: "EDIT_AGREEMENT_INVESTMENT",
  EDIT_AGREEMENT_VISIBILITY: "EDIT_AGREEMENT_VISIBILITY",
  EDIT_AGREEMENT_PERMISSIONS: "EDIT_AGREEMENT_PERMISSIONS",
  EDIT_RECOMMENDER: "EDIT_RECOMMENDER",
  REMOVE_RECOMMENDER: "REMOVE_RECOMMENDER",
  EDIT_INVITATIONS: "EDIT_INVITATIONS",
};

export const AgreementLevelName = {
  AGENT: "AGENT",
  AGENT_MANAGER: "AGENT_MANAGER",
  REGIONAL_MANAGER: "REGIONAL_MANAGER",
  SALES_DIRECTOR: "SALES_DIRECTOR",
  CCO: "CCO",
};

export const HierarchyViewTypeEnum = {
  DIRECTLY: "DIRECTLY",
  ALL: "ALL",
};

export const selectMenuProps = {
  getContentAnchorEl: null,
  anchorOrigin: {
    vertical: "center",
    horizontal: "center",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "center",
  },
};

export const DIALOG_OPTION = {
  ARCHIVE: "ARCHIVE",
  CHANGE_AGENT: "CHANGE_AGENT",
  CHANGE_AGENT_LEVEL: "CHANGE_AGENT_LEVEL",
  CHANGE_COMMISSION_LIMIT: "CHANGE_COMMISSION_LIMIT",
  CHANGE_JOB_TITLE: "CHANGE_JOB_TITLE",
  CHANGE_MANAGER_MONTHLY_COMMISSION: "CHANGE_MANAGER_MONTHLY_COMMISSION",
  CHANGE_MANAGER_ONE_TIME_COMMISSION: "CHANGE_MANAGER_ONE_TIME_COMMISSION",
  CHANGE_PERMISSIONS: "CHANGE_PERMISSIONS",
  CHANGE_SEGMENT_DEFAULT: "CHANGE_SEGMENT_DEFAULT",
  CHANGE_VISIBILITY_PERMISSION: "CHANGE_VISIBILITY_PERMISSION",
  DEMOTE_FROM_AGENT: "DEMOTE_FROM_AGENT",
  PROMOTE_TO_AGENT: "PROMOTE_TO_AGENT",
  READ_AGREEMENT: "READ_AGREEMENT",
  REMOVE_AGENT: "REMOVE_AGENT",
  RESTART_AGREEMENT: "RESTART_AGREEMENT",
  DISPLAY_PERMISSIONS: "DISPLAY_PERMISSIONS",
  EDIT_RECOMMENDER: "EDIT_RECOMMENDER",
  REMOVE_RECOMMENDER: "REMOVE_RECOMMENDER",
};

export const USER_LOCALES = [
  { value: "br", input: "app.language.br" },
  { value: "en", input: "app.language.en" },
  { value: "es", input: "app.language.es" },
];

export const PERSON_TYPE = {
  NATURAL_PERSON: "NATURAL_PERSON",
  COMPANY: "COMPANY",
};

export const PERSON_TYPES = [
  { value: "NATURAL_PERSON", input: "app.naturalPerson" },
  { value: "COMPANY", input: "app.person.legal" },
];

export const LOCALE_BY_LANGUAGE = {
  en: "en-US",
  br: "pt-BR",
  es: "es-ES",
};

export const getLocaleFromUser = (language) => {
  switch (language) {
    case "en":
      return LOCALE_BY_LANGUAGE.en;
    case "es":
      return LOCALE_BY_LANGUAGE.es;
    case "br":
      return LOCALE_BY_LANGUAGE.br;
    default:
      return LOCALE_BY_LANGUAGE.en;
  }
};

export const getDateWithLocale = (date, language) => {
  if (!date) return "-";
  const locale = getLocaleFromUser(language);
  const dateFormatted = new Date(date).toLocaleDateString(locale);
  return dateFormatted;
};

export const getNestedValue = (obj, path) => path.split(".").reduce((acc, key) => acc?.[key], obj);

export const GENDER = {
  MALE: "MALE",
  FEMALE: "FEMALE",
  PREFER_NOT_TO_SAY: "PREFER_NOT_TO_SAY",
};

export const GENDER_OPTIONS = Object.keys(GENDER).map((key) => ({
  value: GENDER[key],
  input: `app.gender.${key}`,
}));

export const USER_FILTER_KEYS = {
  COUNTRIES: "countries",
  STATES: "states",
  CITIES: "cities",
  ROLES: "roles",
  CUSTOMER_SITUATIONS: "customerSituations",
  AGENT_SITUATIONS: "agentSituations",
  AGE_RANGES: "ageRanges",
  EMAIL_CONFIRMATION: "isEmailConfirmed",
  USERS: "selectedUsers",
  HAS_BENEFICIARY: "hasBeneficiary",
  AGENTS: "selectedAgents",
  SELECTED_MONTH_YEAR: "selectedMonthYear",
  GROUP: "group",
  ORDER_BY: "orderBy",
  SORT: "sort",
};

export const PeriodType = {
  MONTH: "month",
};

export const ReportByGroupParam = {
  CITY: "CITY",
  STATE: "STATE",
  USER_AGE: "USER_AGE",
  GENDER: "GENDER",
};

export const REPORT_BY_GROUP_OPTIONS = Object.keys(ReportByGroupParam).map((key) => ({
  value: ReportByGroupParam[key],
  label: `app.report.byGroup.${key}`,
}));

export const SORT = {
  asc: "ASC",
  desc: "DESC",
  ASC: "ASC",
  DESC: "DESC",
};

export const CONTRACT_SITUATIONS = {
  AWAITING_FIRST_SIGNATURE: "AWAITING_FIRST_SIGNATURE",
  AWAITING_DEPOSIT: "AWAITING_DEPOSIT",
  AWAITING_VALIDATION: "AWAITING_VALIDATION",
  AWAITING_SECOND_SIGNATURE: "AWAITING_SECOND_SIGNATURE",
  EXECUTING: "EXECUTING",
  AWAITING_REDEEM: "AWAITING_REDEEM",
  REDEEM_REQUESTED: "REDEEM_REQUESTED",
  FINISHED: "FINISHED",
  CANCELED: "CANCELED",
};

export const CONTRACT_SITUATIONS_DEFAULT = [
  CONTRACT_SITUATIONS.AWAITING_FIRST_SIGNATURE,
  CONTRACT_SITUATIONS.AWAITING_DEPOSIT,
  CONTRACT_SITUATIONS.AWAITING_VALIDATION,
  CONTRACT_SITUATIONS.AWAITING_SECOND_SIGNATURE,
  CONTRACT_SITUATIONS.EXECUTING,
];

export const INTITE_STATUS = {
  ACTIVE: "ACTIVE",
  USED: "USED",
  REVOKED: "REVOKED",
  EXPIRED: "EXPIRED",
};

export const CONTRACT_DURATIONS = [3, 6, 12, 18, 24, 36, 48];

export const CUSTOMER_ROUTES = {
  ADMIN: "/user",
  AGENT: "/customer-detail",
  FINANCE: "/user",
  KYC: "/user",
  MANAGER: "/user-detail",
};

export const getActualRole = (user) => (user.role !== Roles.Agent ? user.role : isAgentManager(user) ? Roles.AgentsManager : Roles.Agent);

export const hasActualRole = (roleArray, user) => roleArray.includes(getActualRole(user));

export const isAgentOf = (agent, customer) => agent.id === customer.consultant.id;

export const isAgent = (agent) => agent.role === Roles.Agent && agent?.contractAgent?.contractAgentClass?.levelName?.toLowerCase() === AgreementLevelName.AGENT;

export const isAgentManager = (manager) =>
  manager.role === Roles.Agent &&
  (manager?.contractAgent?.contractAgentClass?.levelName?.toUpperCase() === AgreementLevelName.AGENT_MANAGER ||
    manager?.contractAgent?.contractAgentClass?.levelName?.toUpperCase() === AgreementLevelName.REGIONAL_MANAGER ||
    manager?.contractAgent?.contractAgentClass?.levelName?.toUpperCase() === AgreementLevelName.SALES_DIRECTOR ||
    manager?.contractAgent?.contractAgentClass?.levelName?.toUpperCase() === AgreementLevelName.CCO);

export const isAgentManagerOf = (manager, agentOrCustomer) => isAgentManager(manager) && isAgentOf(manager, agentOrCustomer);

export const isUserBelow = (user, userAbove) => user?.consultant?.id === userAbove?.id;

export const isUserBelowManager = (user, manager) =>
  isAgentManager(manager) && (isUserBelow(user, manager) || isUserBelow({ id: user.id, consultant: { id: user?.consultant?.consultantId } }, manager));

export const isPremiumContract = (c) => c.segment.premium;

export const contractProgress = (contract) => {
  const dateOpen = moment(contract.initialDate ?? contract.createdAt);
  const dateClose = moment(contract.dueDate);

  const totalDays = dateClose.diff(dateOpen, "days");
  if (totalDays <= 0) return 0;

  const elapsedDays = moment().diff(dateOpen, "days");

  let progress = Math.round((elapsedDays / totalDays) * 100);
  progress = Math.max(0, Math.min(progress, 100));

  return progress;
};

export const removeEmptyFields = (obj) => {
  const entries = Object.entries(obj);

  const filteredEntries = entries.filter(([_, v]) => {
    const isEmptyValue = v === null || v === undefined;
    const isEmptyString = typeof v === "string" && v.trim() === "";
    const isEmptyArray = Array.isArray(v) && v.length === 0;

    return !isEmptyValue && !isEmptyString && !isEmptyArray;
  });

  return Object.fromEntries(filteredEntries);
};

export const resolveBooleanList = (arr) => {
  if (!arr || arr.length === 0) return null;
  if (arr.length === 1) return arr[0];

  return null;
};

const hasValue = (value) => (Array.isArray(value) ? value.length > 0 : !!value);

export const getEmptyFields = (filters, requiredKeys) => {
  const emptyFields = requiredKeys.filter((key) => !hasValue(filters[key]));

  return {
    hasAllRequiredFields: emptyFields.length === 0,
    emptyFields,
  };
};

export const calcProportionalYield = (c) => {
  return (c.segment.baseYield * c.type.maxMonthlyYield) / 100;
};

export const capitalCaseNormalizer = (value) => {
  if (typeof value !== "string") return value;
  return value
    .split(" ")
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1).toLowerCase())
    .join(" ");
};

export const userDocumentNormalizer = (user) => {
  if (!user) {
    return null;
  }
};

export const formattCPF = (cpf) => {
  cpf = cpf.replace(/\D/g, "");
  cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
  cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
  cpf = cpf.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  return cpf;
};

export const formattCNPJ = (cnpj) => {
  cnpj = cnpj.replace(/[^a-zA-Z0-9]/g, "").toUpperCase(); //Remove tudo o que não é caractere alfanumérico
  cnpj = cnpj.replace(/^([a-zA-Z0-9]{2})([a-zA-Z0-9])/, "$1.$2"); //Coloca ponto entre o segundo e o terceiro caractere
  cnpj = cnpj.replace(/^([a-zA-Z0-9]{2})\.([a-zA-Z0-9]{3})([a-zA-Z0-9])/, "$1.$2.$3"); //Coloca ponto entre o quinto e o sexto caractere
  cnpj = cnpj.replace(/\.([a-zA-Z0-9]{3})([a-zA-Z0-9])/, ".$1/$2"); //Coloca uma barra entre o oitavo e o nono caractere
  cnpj = cnpj.replace(/([a-zA-Z0-9]{4})([a-zA-Z0-9])/, "$1-$2"); //Coloca um hífen depois do bloco de quatro caracteres
  return cnpj;
};

const documentFormatters = {
  CPF: formattCPF,
  CNPJ: formattCNPJ,
};

/**
 * Formata o documento de acordo com o tipo informado.
 * @param {String} docNumber
 * @param {String} docType
 * @param {Component} ComponentIfEmpty
 * @returns String com o docNumber formatado de acordo com o docType ou ComponentIfEmpty caso algum parâmetro informado esteja vazio.
 */
// Boa sorte tentanto entender isso! Muahahahaaaa! <-risada malígna
export const documentFormatter = (docNumber, docType, ComponentIfEmpty = <></>) =>
  !docNumber || !docType ? ComponentIfEmpty : (documentFormatters[docType] ? documentFormatters[docType] : (x) => x)(docNumber);

/**
 * Formata o documento do objeto usuário informado.
 * @param {Object} user
 * @param {String} user.documentId
 * @param {String} user.documentType
 * @param {Component} ComponentIfEmpty
 * @returns String com o documentId formatado de acordo com o documentType ou ComponentIfEmpty caso algum parâmetro informado esteja vazio.
 */
export const userDocumentFormatter = (user, ComponentIfEmpty = <></>) => (!user ? null : documentFormatter(user.documentId, user.documentType, ComponentIfEmpty));

export const dateFromServer = (dateOrStr) => moment(dateOrStr).toDate();

export const fullDateFormatter = (dateFormat) => {
  let idLocale = require("moment/locale/pt-br");
  Moment.updateLocale("pt-br", idLocale);
  let date = null;
  dateFormat !== null && (date = Moment(dateFormat).format("DD/MM/YYYY HH:mm:ss"));
  return date;
};

export const dateFormatter = (dateFormat) => {
  let idLocale = require("moment/locale/pt-br");
  Moment.updateLocale("pt-br", idLocale);
  let date = null;
  dateFormat !== null && (date = Moment(dateFormat).format("DD/MM/YYYY"));
  return date;
};

export const diffDatedays = (date, initialDate = moment(new Date())) => {
  const duration = moment.duration(initialDate.diff(date));
  // Mostra a diferença em dias
  return Math.round(duration.asDays());
};

export const timeFormatter = (dateFormat) => {
  let idLocale = require("moment/locale/pt-br");
  Moment.updateLocale("pt-br", idLocale);
  let date = null;
  dateFormat !== null && (date = Moment(dateFormat).format("HH:mm:ss"));
  return date;
};

export const numberFormatter = (value, btc, number) => {
  const formattedValue = Intl.NumberFormat("en", {
    minimumFractionDigits: btc ? 5 : 2,
    maximumFractionDigits: btc ? 5 : 2,
    useGrouping: true,
  }).format(value);
  if (number) return Number(formattedValue);
  return formattedValue;
};

export const formatForMoney = (value, decimal) => {
  var numero = value.toFixed(decimal).split(".");
  numero[0] = numero[0].split(/(?=(?:...)*$)/).join(".");
  return numero.join(",");
};
/*
 * @param {*} money Valor
 * @param {*} symbol simbolo a ser usado
 * @param {*} decimalPlaces quantidade de casas decimais
 */
export const formatMoney = (money, symbol, decimalPlaces = 2) => {
  let value = "";
  if (symbol == "BRL") {
    value = money.toLocaleString("pt-BR", {
      style: "currency",
      currency: symbol,
    });
  } else {
    value = symbol + " " + money.toLocaleString("pt-BR", { minimumFractionDigits: decimalPlaces });
  }

  return value;
};

export function formatAndValidateNumber(input, min = 0, max = 100) {
  let numberValue = Number(input);
  if (isNaN(numberValue) || numberValue < min || numberValue > max) {
    return null;
  }
  return numberValue;
}

export function formatPercentLocale(value, locale = "pt-BR", decimals = 2) {
  const normalized = normalizePercentValue(value, decimals);

  const formatted = normalized.toLocaleString(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

  return `${formatted}%`;
}

export function normalizePercentValue(value, decimals = 2) {
  if (value === null || value === undefined || isNaN(value)) return 0;

  const percentValue = value * 100;
  return Number(percentValue.toFixed(decimals));
}

const formatNumber = ({ value, decimalPlaces = 2, fallback = "-", userLocale = "br", prefix = "", suffix = "" } = {}) => {
  if (value === null || value === undefined || value === "") {
    return fallback;
  }

  const number = Number(value);

  if (Number.isNaN(number)) {
    return fallback;
  }

  const locale = LOCALE_BY_LANGUAGE[userLocale] ?? LOCALE_BY_LANGUAGE.br;

  const formatted = new Intl.NumberFormat(locale, {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  }).format(number);

  return `${prefix}${formatted}${suffix}`;
};

export const formatCurrency = (params) => formatNumber(params);

export const formatPercentage = (params) => formatNumber({ ...params, suffix: "%" });

export const onlyNumbers = (e) => {
  const allowKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "Enter"];
  if (allowKeys.includes(e.key)) return;

  const isNumber = /^[0-9]/.test(e.key); //apenas numeros
  if (!isNumber) e.preventDefault();
};

export const filterOnlyNumbers = (e) => {
  e.target.value = e.target.value.replace(/\D+/g, ""); // tira tudo que não for número
};

export const numberNormalizer = (value) => {
  if (!value) {
    return value;
  }
  return value.replace(/[^\d]/g, "");
};

export const docNormalizer = (value) => {
  if (!value) {
    return value;
  }
  return value.replace(/[^\w.-]/g, "");
};

/**
 * @param {*} value texto contendo o número a ser normalizado.
 * @returns o número normalizado, contendo apenas digitos e os carateres "+", "-", ".", "(", ")" e " " (espaço em branco).
 */
export const phoneNormalizer = (value) => {
  if (!value) {
    return value;
  }
  return value.replace(/[^\d+-.)( ]/g, "");
};

export const cpfNormalizer = (value) => {
  if (!value) {
    return value;
  }
  const onlyNums = value.replace(/[^\d]/g, "");
  if (onlyNums.length <= 3) {
    return onlyNums;
  }
  if (onlyNums.length <= 6) {
    return `${onlyNums.slice(0, 3)}.${onlyNums.slice(3)}`;
  }
  if (onlyNums.length <= 9) {
    return `${onlyNums.slice(0, 3)}.${onlyNums.slice(3, 6)}.${onlyNums.slice(6)}`;
  }
  if (onlyNums.length <= 11) {
    return `${onlyNums.slice(0, 3)}.${onlyNums.slice(3, 6)}.${onlyNums.slice(6, 9)}-${onlyNums.slice(9)}`;
  }
  return onlyNums;
};

export const cnpjNormalizer = (value) => {
  if (!value) {
    return value;
  }
  return formattCNPJ(value);
};

/**
 * Executa um consolee.log apenas se estiver em desenvolvimento, evitando logs no ambiente de produção.
 */
export const logDev = (...params) => {
  if (process.env.NODE_ENV !== "production") {
    console.log(...params);
  }
};

/**
 * Atalho para consolee.logError. Executa também no ambiente de produção.
 */
export const logError = (...params) => {};

/**
 * Realiza uma chamada ao servidor para o métodos e url providos e retorna uma promise
 * - Em caso de sucesso, ".then" recebe o objeto retornado pelo servidor.
 * - Em caso de erro, ".catch" recebe uma exceção com nome, message e possivelmente mais dados (se o erro for do servidor).
 * - Se o parâmetro disabledErrorAlert for true, não é mostrado um alerta de erro ao receber erros do servidor.
 */
export const requestAndDispatch = (type, method, url, params, auth, disabledErrorAlert, funcName) => async (dispatch) => {
  try {
    logDev("[dispatchRequestPromise] REQUEST: " + funcName, method, url, params);
    const response = await performRequest(method, url, params, auth);
    logDev("[dispatchRequestPromise] RESPONSE: " + funcName, response);
    const data = response.data.data ? response.data.data : response.data;
    try {
      dispatch({ type: type, payload: data });
    } catch (ex2) {
      logError("[dispatchRequestPromise] Erro no dispatch", ex2);
      throw ex2;
    }
    return data;
  } catch (e) {
    e.response.data.name = e.response.data.error;
    logError("[dispatchRequestPromise] ERROR: " + funcName, e.response);
    if (!disabledErrorAlert) dispatch(alerts.showErrorMessage(e.response.data.message));
    throw e.response.data;
  }
};

/**
 * Esta rotina serve para formatar números que já não estão formatados.
 * Retorna o número em formato de celular do Brasil apenas, que não é adequado para
 * telefones fixos (ainda muito usados por empresas) nem para telefones de outro pais.
 * Inclusive, assume que número NÃO contem o código do pais na frente.
 *
 * Desde Abril/2021 a plataforma não salva apenas os números na base, mas sim,
 * a string completa que o usuário digitar no campo telefone. Por isso, ela vai incluir
 * formatação com espaços, "-" ou "(". Em função disto, esta rotina testa a presença de
 * caracteres "não digito" no número. Caso detecte a presença de algum, retorna
 * a string sem modificação.
 *
 * Temporariamente, para faciliar a identificação, na interface, de números que foram
 * formatados, esta rotina acrecenta um ponto ao final do número formato por ela.
 *
 * @param {*} phoneNumber string com o número a ser formatado
 * @returns retorna o número em formato do brasil (99) 9 9999-9999.
 */
export const phoneFormatter = (phoneNumber) => {
  if (phoneNumber && phoneNumber.length >= 10 && /^\d+$/g.test(phoneNumber))
    return "(" + phoneNumber.substr(0, 2) + ") " + phoneNumber.substr(2, 1) + " " + phoneNumber.substr(3, 4) + "-" + phoneNumber.substr(7);
  else return phoneNumber;
};

export const capitalizeFirstLetter = (string) => {
  //verifica se é uma string e deixa a primeira letra em maiscula
  if (!!string) {
    return string[0] ? `${string[0].toUpperCase()}${string.substring(1)}` : "";
  }
};

export const getDataFromServer = (method, path, params, auth) =>
  new Promise(async (resolve, reject) => {
    await performRequest(method, path, params, auth)
      .then((response) => resolve(response.data.data))
      .catch((e) => reject(e));
  });

export const getDataFromWeb = (method, url, data) =>
  new Promise(async (resolve, reject) => {
    await fetch(url, { method })
      .then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error, status = " + response.status);
        }
        resolve(response.json());
      })
      .catch((e) => reject(e));
  });

export const downloadBase64 = (base64Data, fileName) => {
  const downloadLink = document.createElement("a");
  downloadLink.href = "data:application/pdf;base64," + base64Data;
  downloadLink.download = fileName;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
};

export class DialogManager {
  openDialog = undefined;

  constructor(onChange) {
    if (onChange) this.onChange = onChange;
  }

  onChange = () => {};

  open = (dialogId) => {
    this.openDialog = dialogId;
    this.onChange(this.openDialog);
  };

  close = () => {
    this.openDialog = undefined;
    this.onChange(this.openDialog);
  };

  isOpen = (dialogId) => {
    return dialogId != null && dialogId != undefined && this.openDialog == dialogId;
  };
}

export const validateAddress = (values, dispatch, props, currentFieldName) => {
  const previousErrors = props.asyncErrors;
  return getDataFromWeb("GET", `https://api.blockcypher.com/v1/btc/main/addrs/${values.address}`, null).catch((e) => {
    throw Object.assign({}, previousErrors, {
      address: "app.walletAddress.invalid",
    });
  });
};

export const validateCriptoAddress = (address, network) =>
  new Promise(async (resolve, reject) => {
    const networkQueryParam = network ? `?network=${encodeURIComponent(network)}` : "";
    await getDataFromServer("GET", `/ext/hash/${address}${networkQueryParam}`, null, true)
      .then((data) => resolve(data))
      .catch((e) => reject(e.response.data));
  });

/**
 *
 * Valida se o usuário do contrato é o mesmo do id ou se é admin
 */
export const validateContract = (currentUser, contract) => {
  if (currentUser.role == Roles.Admin || currentUser.id == contract.user.id) {
    return true;
  } else {
    return false;
  }
};

export const validateEmail = async (values, dispatch, props, currentFieldName) => {
  const previousErrors = props.asyncErrors;
  return new Promise((resolve, reject) => {
    performRequest("GET", `/user/validateEmail?email=${values.email}`, null)
      .then((response) => {
        if (!response.data.success) {
          return reject(
            Object.assign({}, previousErrors, {
              email: "app.email.inuse",
            }),
          );
        }
        if (props.asyncErrors) {
          return reject(Object.assign({}, { ...props.asyncErrors, email: undefined }));
        }
        return resolve();
      })
      .catch((e) => {
        reject(
          Object.assign({}, previousErrors, {
            email: "app.server.connect.error",
          }),
        );
      });
  });
};

export const validateDocumentId = async (values, dispatch, props, currentFieldName) => {
  return new Promise((resolve, reject) => {
    if (!values.documentId) return resolve();
    performRequest("GET", `/user/validateDocumentId?documentId=${values.documentId}&taxResidence=${values.taxResidence}`, null)
      .then((response) => {
        if (!response.data.success) {
          return reject(
            Object.assign({}, props.asyncErrors, {
              documentId: `app.documentId.exists`,
            }),
          );
        }
        if (props.asyncErrors) {
          return reject(Object.assign({}, { ...props.asyncErrors, documentId: undefined }));
        }
        return resolve();
      })
      .catch((e) => {
        reject(
          Object.assign({}, props.asyncErrors, {
            documentId: "app.server.connect.error",
          }),
        );
      });
  });
};

export const validateDocumentIdAdmin = async (values, dispatch, props, currentFieldName) => {
  const previousErrors = props.asyncErrors;
  return await performRequest("GET", `/user/validateDocumentIdAdmin?documentId=${values.documentId}&userId=${props.user.id}`, null, true)
    .then((response) => {
      if (!response.data.success) {
        throw Object.assign({}, previousErrors, {
          documentId: "Cpf já utilizado",
        });
      }
    })
    .catch((e) => {
      throw Object.assign({}, previousErrors, {
        documentId: "Cpf já utilizado",
      });
    });
};

export const validateAgentId = async (values, dispatch, props, currentFieldName) => {
  const previousErrors = props.asyncErrors;
  return new Promise((resolve, reject) => {
    if (!values.agentId) return resolve();
    performRequest("GET", `/user/existsAgent/${values.agentId}`, null)
      .then((response) => {
        if (!response.data.success) {
          return reject(
            Object.assign({}, previousErrors, {
              agentId: "app.agent.notFound",
            }),
          );
        }
        if (props.asyncErrors) {
          return reject(Object.assign({}, { ...props.asyncErrors, agentId: undefined }));
        }
        return resolve();
      })
      .catch((e) => {
        return reject(
          Object.assign({}, previousErrors, {
            agentId: "app.server.connect.error",
          }),
        );
      });
  });
};

function composeAsyncValidators(validatorFns) {
  return async (values, dispatch, props, field) => {
    const validatorFn = validatorFns[field];
    if (!validatorFn) {
      return Promise.resolve();
    }
    return await validatorFn(values, dispatch, props, field);
  };
}

export const asyncValidateRegister = composeAsyncValidators({
  email: validateEmail,
  documentId: validateDocumentId,
  taxResidence: validateDocumentId,
  // agentId: validateAgentId,
});

/**
 *
 * @param {*} date  recebe uma data
 * @param {*} day  recebe a quantidade de  dias para somar
 *  O retorno será a data mais a quantidade de dias
 */
export const addDays = (date, daysToAdd = 0) => {
  const dateTemp = moment(date);
  dateTemp.hour(0);
  dateTemp.minute(0);
  dateTemp.second(0);
  dateTemp.millisecond(0);
  const newDate = dateTemp.add(daysToAdd, "days");
  return newDate;
};

/**
 *
 * @param {Date} date  recebe uma data para base de cálculo
 * @param {number} daysToAdd  recebe quantidade de dias úteis para incrementar, padrão zero
 * @returns {Moment.Moment} Data com a quantidade de dias
 */
export const addBusinessDays = (date, daysToAdd = 0) => {
  const dateTemp = moment(date);
  dateTemp.hour(0);
  dateTemp.minute(0);
  dateTemp.second(0);
  dateTemp.millisecond(0);
  if (!dateTemp.isBusinessDay()) {
    dateTemp.nextBusinessDay();
  }
  const resultDate = dateTemp.businessAdd(daysToAdd);
  return resultDate;
};

/**
 *
 *
 * @param {*} date  recebe uma data
 * @param {*} day  adiciona a quantidade de  dias para subtrair
 *  O retorno sera a a data menos a quantidade de dias informada
 */
export const subtraiData = (date, day = 0) => {
  const dateTemp = moment(date);
  dateTemp.hour(0);
  dateTemp.minute(0);
  dateTemp.second(0);
  dateTemp.millisecond(0);
  const newDate = dateTemp.businessSubtract(day)._d;
  return newDate;
};

/**
 *
 * @param {*} dateA  Passa a data maior
 * @param {*} dateB  Passa a data menor
 * O retorno sera a diferenca de dias
 */
export const difDate2 = (date1, date2) => {
  const dateA = moment(date1);
  dateA.hour(0);
  dateA.minute(0);
  dateA.second(0);
  dateA.millisecond(0);
  var dateB = moment(date2);
  dateB.hour(0);
  dateB.minute(0);
  dateB.second(0);
  dateB.millisecond(0);
  var dateDiff = moment(dateA).businessDiff(moment(dateB));
  return dateDiff;
};
/**
 *
 * @param {*} date1  Passa a data maior
 * @param {*} dateA  Passa a data menor
 * O retorno sera a diferenca de dias
 */
export const difDate = (date) => {
  var dateA = moment(date, "YYYY-MM-DD");
  dateA.hour(0);
  dateA.minute(0);
  dateA.second(0);
  dateA.millisecond(0);
  var dateB = moment();
  dateB.hour(0);
  dateB.minute(0);
  dateB.second(0);
  dateB.millisecond(0);
  var dateDiff = dateB.businessDiff(dateA);
  return dateDiff;
};
/**
 *
 * @param {*} date1  Passa a data maior
 * @param {*} dateA  Passa a data menor
 * O retorno sera a diferenca de dias
 */
export const difDateSignal = (endDate) => {
  const dateA = moment(endDate);
  dateA.hour(0);
  dateA.minute(0);
  dateA.second(0);
  dateA.millisecond(0);
  const dateB = moment();
  dateB.hour(0);
  dateB.minute(0);
  dateB.second(0);
  dateB.millisecond(0);
  const dateDiff = dateB.businessDiff(dateA);
  return dateA.isBefore(dateB) ? -dateDiff : dateDiff;
};
/**
 *
 * @param {*} date1  Passa a data maior
 * @param {*} dateA  Passa a data menor
 * O retorno sera a diferenca de dias
 */
export const difDateSignal2 = (startDate, endDate) => {
  const dateA = moment(endDate);
  dateA.hour(0);
  dateA.minute(0);
  dateA.second(0);
  dateA.millisecond(0);
  const dateB = moment(startDate);
  dateB.hour(0);
  dateB.minute(0);
  dateB.second(0);
  dateB.millisecond(0);
  const dateDiff = dateB.businessDiff(dateA);
  return dateA.isBefore(dateB) ? -dateDiff : dateDiff;
};
// teste
export const changeColorPendent = (diff) => {
  if (diff == 1 || diff > 4) {
    return "textPrimary";
  }
  if (diff == 2) {
    return "primary";
  }
  if (diff == 3 || diff == 4) {
    return "error";
  }
};

export const orderAscName = (a, b) => {
  var nameA = a.account.user.name.toLowerCase();
  var nameB = b.account.user.name.toLowerCase();
  if (nameA > nameB) {
    return 1;
  }
  if (nameA < nameB) {
    return -1;
  }
  return 0;
};
export const orderDescName = (a, b) => {
  var nameA = a.account.user.name.toLowerCase();
  var nameB = b.account.user.name.toLowerCase();
  if (nameA > nameB) {
    return -1;
  }
  if (nameA < nameB) {
    return 1;
  }
  return 0;
};

export const orderAscDate = (a, b) => {
  var dateA = moment(new Date(a.authorizeDate));
  var dateB = moment(new Date(b.authorizeDate));

  if (moment(dateA).isBefore(dateB)) {
    return 1;
  } else {
    return -1;
  }
};
export const orderDescDate = (a, b) => {
  var dateA = moment(new Date(a.authorizeDate));
  var dateB = moment(new Date(b.authorizeDate));

  if (moment(dateA).isAfter(dateB)) {
    return 1;
  } else {
    return -1;
  }
};

export const formatTextToHTML = (text) => {
  text = text.replace(/\n/g, "<br>");
  return text;
};

// FORMATA O FORMULARIO PARA PARAMETROS GET
export const formatParamsGet = (formProps) => {
  let params = formProps
    ? "?" +
      Object.keys(formProps)
        .map(function (key) {
          if (Array.isArray(formProps[key])) {
            return key + "=" + formProps[key].join(",");
          } else if (typeof formProps[key] === "string" && formProps[key].trim().length > 0) {
            return key + "=" + formProps[key].trim();
          } else {
            return key + "=" + formProps[key];
          }
          return null;
        })
        .join("&")
    : "";
  return params;
};

/*
 * Serve para verificar se um objeto esta vazio
 */
export const isEmptyObject = (obj) => {
  return Object.keys(obj).length === 0;
};
/*
 * Serve para verificar se um array esta vazio, se nem a posição 0 ele possui.
 */
export const ArrayisEmpty = (obj) => {
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) return false;
  }
  return true;
};

export const resizeImageFile = (file, maxWidth, maxHeight, rotation, quality = 100) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      maxWidth,
      maxHeight,
      "JPEG",
      quality,
      rotation,
      (uri) => {
        resolve(uri);
      },
      "blob",
    );
  });

export const debounce = (callback, delay = 500) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      callback(...args);
    }, delay);
  };
};

export const resolveErrorMessage = (error) => {
  return error?.response?.data?.message ?? error?.message ?? "app.error.generic";
};

export const resolveListErrors = (error) => {
  const data = error?.response?.data ?? error?.data ?? error;

  if (data?.errors?.length) return data.errors;

  return [{ message: resolveErrorMessage(error) }];
};

/**
 * Array que marca em amarelo o menu inferior correspondente a pagina acessada
 */
export const ListRoutes = {
  Admin: [
    { id: 0, path: "/dashboard" },
    { id: 1, path: "/history-withdrawal" },
    { id: 1, path: "/withdraw" },
    { id: 4, path: "/contractReport" },
    { id: 4, path: "/userReport" },
    { id: 2, path: "/contracts" },
    { id: 2, path: "/contract" },
    { id: 4, path: "/reports/users" },
    { id: 4, path: "/reports/age-range" },
    { id: 4, path: "/reports/state" },
    { id: 4, path: "/reports/city" },
    { id: 4, path: "/reports/contract/by-agent" },
    { id: 4, path: "/reports/contract/by-team-hierarchy" },
    { id: 4, path: "/reports/contract/all-below" },
    { id: 4, path: "/reports/contract/" },
    { id: 4, path: "/reports" },
    { id: 4, path: "/report/agents-financial" },
    { id: 4, path: "/managerAndAgents" },
    { id: 0, path: "/customerFormData" },
    { id: 0, path: "/customerDocs" },
    { id: 1, path: "/customers" },
    { id: 1, path: "/customer" },
    { id: 2, path: "/editContract" },
    { id: 2, path: "/newContract" },
    { id: 2, path: "/newContact" },
    { id: 2, path: "/newUser" },
    { id: 2, path: "/users" },
    { id: 2, path: "/user" },
    { id: 2, path: "/accountUser/" },
    { id: 3, path: "/history" },
    { id: 2, path: "/authorize" },
  ],
  Agent: [
    { id: 3, path: "/authorize" },
    { id: 0, path: "/changePassword" },
    { id: 0, path: "/confirmEmailForm" },
    { id: 0, path: "/confirmEmail" },
    { id: 1, path: "/contractAgent/" },
    { id: 1, path: "/contractDetail/" },
    { id: 1, path: "/contractHistory/" },
    { id: 1, path: "/contracts" },
    { id: 1, path: "/contract/" },
    { id: 0, path: "/customerFormData" },
    { id: 0, path: "/customerDocs" },
    { id: 2, path: "/customers" },
    { id: 2, path: "/contractReport" },
    { id: 2, path: "/customer/" },
    { id: 2, path: "/customer-detail" },
    { id: 2, path: "/customer-management" },
    { id: 2, path: "/management" },
    { id: 2, path: "/reports/contract/by-customer" },
    { id: 2, path: "/reports/contract/" },
    { id: 0, path: "/dashboard" },
    { id: 0, path: "/language" },
    { id: 1, path: "/editContract/" },
    { id: 3, path: "/history" },
    { id: 4, path: "/help" },
    { id: 0, path: "/more" },
    { id: 1, path: "/newContract" },
    { id: 2, path: "/userContract/" },
    { id: 3, path: "/withdraw" },
    { id: 1, path: "/earnings" },
  ],
  AgentsManager: [
    { id: 3, path: "/authorize" },
    { id: 0, path: "/changePassword" },
    { id: 0, path: "/confirmEmailForm" },
    { id: 0, path: "/confirmEmail" },
    { id: 1, path: "/contractAgent/" },
    { id: 1, path: "/contractDetail/" },
    { id: 1, path: "/contractHistory/" },
    { id: 1, path: "/contracts" },
    { id: 1, path: "/contract/" },
    { id: 0, path: "/customerFormData" },
    { id: 0, path: "/customerDocs" },
    { id: 2, path: "/customer-management" },
    { id: 2, path: "/team-management" },
    { id: 2, path: "/customers" },
    { id: 2, path: "/customer/" },
    { id: 2, path: "/customer-detail" },
    { id: 0, path: "/dashboard" },
    { id: 0, path: "/language" },
    { id: 1, path: "/editContract/" },
    { id: 2, path: "/management" },
    { id: 3, path: "/history" },
    { id: 0, path: "/more" },
    { id: 1, path: "/newContract" },
    { id: 2, path: "/userContract/" },
    { id: 2, path: "/user-detail" },
    { id: 3, path: "/withdraw" },
    { id: 2, path: "/report/agents-financial" },
    { id: 2, path: "/reports/age-range" },
    { id: 2, path: "/reports/users/by-group" },
    { id: 2, path: "/reports/contract/by-agent" },
    { id: 2, path: "/reports/contract/by-customer" },
    { id: 2, path: "/reports/contract/by-team-hierarchy" },
    { id: 2, path: "/reports/contract/all-below" },
    { id: 2, path: "/reports/contract/" },
    { id: 2, path: "/reports/users" },
    { id: 2, path: "/reports/state" },
    { id: 2, path: "/reports/city" },
    { id: 4, path: "/report" },
    { id: 2, path: "/contractReport" },
    { id: 2, path: "/managerAndAgents" },
    { id: 1, path: "/earnings" },
  ],
  Auditor: [
    { id: 0, path: "/authorize" },
    { id: 0, path: "/changePassword" },
    { id: 0, path: "/confirmEmailForm" },
    { id: 0, path: "/confirmEmail" },
    { id: 1, path: "/contractReportJustOpened" },
    { id: 1, path: "/contractReportRedeemed" },
    { id: 1, path: "/contractReportTerminated" },
    { id: 1, path: "/contractReport" },
    { id: 0, path: "/customerDocs" },
    { id: 0, path: "/customerFormData" },
    { id: 0, path: "/dashboard" },
    { id: 0, path: "/language" },
    { id: 0, path: "/more" },
    { id: 1, path: "/reports" },
  ],
  BusinessManager: [
    { id: 0, path: "/changePassword" },
    { id: 0, path: "/confirmEmailForm" },
    { id: 0, path: "/confirmEmail" },
    { id: 1, path: "/contractReportJustOpened" },
    { id: 1, path: "/contractReportRedeemed" },
    { id: 1, path: "/contractReportTerminated" },
    { id: 1, path: "/contractReport" },
    { id: 0, path: "/customerDocs" },
    { id: 0, path: "/customerFormData" },
    { id: 0, path: "/dashboard" },
    { id: 0, path: "/language" },
    { id: 0, path: "/more" },
    { id: 1, path: "/reports" },
    { id: 1, path: "/userReport" },
  ],
  Customer: [
    { id: 2, path: "/accountUser/" },
    { id: 3, path: "/authorize" },
    { id: 0, path: "/dashboard" },
    { id: 0, path: "/changePassword" },
    { id: 0, path: "/confirmEmailForm" },
    { id: 0, path: "/confirmEmail" },
    { id: 1, path: "/contractHistory/" },
    { id: 1, path: "/contractChart/" },
    { id: 1, path: "/contractDetail/" },
    { id: 1, path: "/contracts" },
    { id: 1, path: "/contract/" },
    { id: 0, path: "/customerFormData" },
    { id: 0, path: "/customerDocs" },
    { id: 2, path: "/customers" },
    { id: 2, path: "/customer" },
    { id: 4, path: "/help" },
    { id: 3, path: "/history" },
    { id: 0, path: "/language" },
    { id: 0, path: "/more" },
    { id: 1, path: "/newContract" },
    { id: 2, path: "/newContact" },
    { id: 2, path: "/newUser" },
    { id: 2, path: "/reaport" },
    { id: 3, path: "/withdraw" },
    { id: 1, path: "/earnings" },
  ],
  FinanceManager: [
    { id: 0, path: "/changePassword" },
    { id: 0, path: "/confirmEmailForm" },
    { id: 0, path: "/confirmEmail" },
    { id: 0, path: "/customerFormData" },
    { id: 0, path: "/customerDocs" },
    { id: 0, path: "/dashboard" },
    { id: 0, path: "/language" },
    { id: 0, path: "/more" },
    { id: 1, path: "/history-withdrawal" },
    { id: 3, path: "/reports" },
    { id: 3, path: "/reports/users" },
    { id: 3, path: "/reports/age-range" },
    { id: 3, path: "/reports/state" },
    { id: 3, path: "/reports/city" },
    { id: 3, path: "/report/agents-financial" },
    { id: 3, path: "/contractReportJustOpened" },
    { id: 3, path: "/contractReportRedeemed" },
    { id: 3, path: "/contractReportTerminated" },
    { id: 3, path: "/contractReport" },
    { id: 3, path: "/userReport" },
    { id: 2, path: "/users" },
    { id: 2, path: "/user" },
    { id: 3, path: "/managerAndAgents" },
  ],
  Kyc: [
    { id: 0, path: "/dashboard" },
    { id: 0, path: "/changePassword" },
    { id: 0, path: "/confirmEmailForm" },
    { id: 0, path: "/confirmEmail" },
    { id: 0, path: "/customerFormData" },
    { id: 0, path: "/customerDocs" },
    { id: 0, path: "/language" },
    { id: 0, path: "/more" },
    { id: 2, path: "/newUser" },
    { id: 1, path: "/users" },
    { id: 1, path: "/user" },
  ],
};
